import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';
import { formatPlays } from '@/utils/videoUtils';

interface HotRankingProps {
  videos: VideoItem[];
}

export default function HotRanking({ videos }: HotRankingProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="mb-6">
        <h2 className="font-display text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          热门视频榜单 TOP10
        </h2>
        <p className="mt-2 text-xs md:text-sm text-foreground-500 pl-4">
          根据平台播放量实时排序，看看大家都在看什么
        </p>
      </div>

      <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
        {videos.map((video, index) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="group flex items-center gap-3 md:gap-4 py-3 border-b border-background-200 cursor-pointer"
            >
              <span
                className={`w-7 shrink-0 text-center font-display text-lg font-bold ${
                  index < 3 ? 'text-accent-500' : 'text-foreground-300'
                }`}
              >
                {index + 1}
              </span>
              <div className="w-24 sm:w-28 shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
                <img
                  src={video.cover}
                  alt={`${video.title}封面`}
                  title={`${video.title} - 在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
                  {video.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 truncate">{video.subtitle}</p>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800">{video.type}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {formatPlays(video.plays)}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}